var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"competition-empty-state"},[_c('Illustration',{staticClass:"placeholder-illustration",attrs:{"image":_vm.illustrationUrl,"large":""}}),_c('div',{staticClass:"placeholder-message"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }